import styles from '../css/BreadCrumb.module.scss';

const Breadcrumb = ({ brands = [], categorias = [], product, outlet }) => {
    const path = (outlet? '/outlet':'/productos')
    return (
        <div className={"py-4 " + styles.url}>
            <p>
                <a href="/">Inicio</a> &gt;
                <a href={path} className='ms-1'>{outlet? 'Outlet':'Productos'}</a> 
                {categorias.length > 0 || brands.length > 0 ? ' > ' : ''}
                {categorias.map(function (elem, i) {
                    return (
                        <>
                            <a href={`${path}?category=${elem.id}`}>{elem.text}</a>
                            {i < categorias.length - 1 ? ' + ' : (product || brands.length > 0 ? ' > ' : '')}
                        </>
                    )
                })}
                {brands.map(function (elem, i) {
                    return (
                        <>
                            <a href={`${path}?marcas=${elem.id}`}>{elem.text}</a>
                            {i < brands.length - 1 ? ' + ' : (product ? ' > ' : '')}
                        </>
                    )
                })}
                {product && <span>{product}</span>}
            </p>
        </div>
    );
};

export default Breadcrumb;